import { type FC } from "react";

import { MailToLinkWrapper } from "./MailToLink.styles";

interface MailToLinkProps {
    displayText: string;
    mailTo: string;
    subject?: string;
    className?: string;
}

export const MailToLink: FC<MailToLinkProps> = ({ displayText, mailTo, subject, className }) => {
    const hrefString = `mailto:${mailTo}?subject=${subject ?? ""}`;
    return (
        <MailToLinkWrapper href={hrefString} className={className}>
            {displayText}
        </MailToLinkWrapper>
    );
};
